<div
  class="font-default rounded-sm border-2 bg-white p-4 text-4xl transition-colors duration-1000 select-none"
  [class]="phase() === 'ROOT' ? 'border-blue-500 text-blue-500' : 'border-morpheme-stem text-morpheme-stem'"
>
  <div class="flex">
    @for (letter of letters(); track $index) {
      @let isHidden = (letter.kind === 'REMOVED' && phase() === 'CHANGED') || (letter.kind === 'ADDED' && phase() !== 'CHANGED');
      <span
        class="inline-block overflow-hidden transition-all duration-1000 ease-in-out"
        [class]="isHidden ? 'max-w-0 opacity-0' : 'max-w-[1em]'"
        >{{ letter.char }}</span
      >
    }
  </div>
</div>
